import React, { useEffect, useState } from "react";
import { FormControl, FormLabel, FormErrorMessage } from "@chakra-ui/react";
import Select from "react-select";
import {
  white,
  newBorder,
  textPrimary,
  textSecondary,
  primary,
} from "../../utils/colors";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { listServiceGroups } from "../../actions/serviceGroupActions";

const FormControlServiceGroupMulti = ({
  label,
  value,
  onChange,
  isRequired,
  isTouched,
  isError,
  errorMessage,
  w,
  isSmall,
  isMulti,
}) => {
  //TRANSLATION
  const { t } = useTranslation();

  // REDUX
  const dispatch = useDispatch();

  const serviceGroupList = useSelector((state) => state.serviceGroupList);
  const { serviceGroups } = serviceGroupList;

  // USE EFFECT LOAD SERVICE GROUPS
  useEffect(() => {
    // Dispatch the action with fetchAll set to true
    dispatch(listServiceGroups("", "", "", "", "", true));
  }, [dispatch]);

  // Convert fetched states into format for react-select
  const serviceGroupOptions = serviceGroups.map((serviceGroup) => ({
    value: serviceGroup._id,
    label: serviceGroup.name,
  }));

  // Map each value to its corresponding option object
  const selectedOption = Array.isArray(value)
    ? value.map((val) => serviceGroupOptions.find((opt) => opt.value === val))
    : [];

  // Custom styles for react-select
  const customStyles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: isError ? "red" : state.isFocused ? newBorder : newBorder,
      borderRadius: "1rem",
      backgroundColor: white,
      border: `1px solid ${newBorder}`,
      fontSize: isSmall ? "0.875rem" : "0.938rem",
      fontWeight: "500",
      minHeight: "2.5rem",
      height: isMulti ? "initial" : isSmall ? "2.5rem" : "3rem",
      padding: "0 0rem",
      ":focus-visible": {
        borderColor: primary,
        boxShadow: `0 0 0 1px ${newBorder}`,
      },
    }),

    singleValue: (provided, state) => ({
      ...provided,
      opacity: state.isDisabled ? 0.5 : 1,
      color: textPrimary,
      ":hover": {
        bg: "red",
      },
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? primary : null,
      color: state.isFocused ? white : state.data.color,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
    }),
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: primary,
      color: white,
      borderRadius: "0.75rem",
      fontSize: "0.938rem",
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      color: state.data.color,
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      ":hover": {
        backgroundColor: state.data.bgDark,
        color: state.data.color,
      },
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontSize: "11px",
      color: textSecondary,
      fontWeight: "500",
    }),
  };

  return (
    <FormControl
      mb={4}
      isRequired={isRequired}
      isInvalid={isTouched && isError}
      w={w}
    >
      <FormLabel fontSize={isSmall ? "xs" : "sm"} position="relative">
        {label}
        {isError && isTouched && (
          <div>
            <FormErrorMessage fontSize="xs">{errorMessage}</FormErrorMessage>
          </div>
        )}
      </FormLabel>

      <Select
        isMulti
        isSearchable
        value={selectedOption}
        onChange={onChange}
        options={serviceGroupOptions}
        placeholder={t("placeholder.selectServiceGroup")}
        styles={customStyles}
      />
    </FormControl>
  );
};

export default FormControlServiceGroupMulti;
